module.exports = __webpack_public_path__ + "static/media/access.c4dcc18c.svg";